/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * Clever Analytics Notifications Public API
 * OpenAPI spec version: 1.0.0
 */
import { notificationsInstance } from '../../api/client';
export type PushCreateRequestPlatform = typeof PushCreateRequestPlatform[keyof typeof PushCreateRequestPlatform];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PushCreateRequestPlatform = {
  IOS: 'IOS',
  ANDROID: 'ANDROID',
  WEB: 'WEB',
} as const;

export interface PushCreateRequest {
  platform: PushCreateRequestPlatform;
  token: string;
}

export type TestUserNotificationRequestAllOf = {
  userId: string;
  language: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  country: string;
  email: string;
};

export type TestUserNotificationRequest = NotificationRequest & TestUserNotificationRequestAllOf;

export type SubscriptionExpiredNotificationRequestAllOf = {
  userId: string;
  language: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  country: string;
  product: string;
  email: string;
};

export type SubscriptionExpiredNotificationRequest = NotificationRequest & SubscriptionExpiredNotificationRequestAllOf;

export type SendNotificationBody = NewReportNotificationRequest | PaymentCompletedNotificationRequest | PaymentRenewWaitingNotificationRequest | PaymentWaitingNotificationRequest | SubscriptionCancelledNotificationRequest | SubscriptionExpiredNotificationRequest | TestUserNotificationRequest;

export type SubscriptionCancelledNotificationRequestAllOf = {
  userId: string;
  language: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  country: string;
  product: string;
  email: string;
  expiresAt: string;
};

export type SubscriptionCancelledNotificationRequest = NotificationRequest & SubscriptionCancelledNotificationRequestAllOf;

export type PaymentWaitingNotificationRequestAllOfPeriod = typeof PaymentWaitingNotificationRequestAllOfPeriod[keyof typeof PaymentWaitingNotificationRequestAllOfPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentWaitingNotificationRequestAllOfPeriod = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY',
} as const;

export type PaymentWaitingNotificationRequestAllOf = {
  userId: string;
  language: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  country: string;
  product: string;
  billingEmail: string;
  bankSubject: string;
  bankName: string;
  bankIban: string;
  bankSwift: string;
  bankAccount: string;
  variable: string;
  amountTotal: string;
  amountCurrency: string;
  period: PaymentWaitingNotificationRequestAllOfPeriod;
  invoiceUrl: string;
  invoiceDueDate: string;
  invoice: NotificationAttachmentRequest;
};

export type PaymentWaitingNotificationRequest = NotificationRequest & PaymentWaitingNotificationRequestAllOf;

export type PaymentRenewWaitingNotificationRequestAllOfPeriod = typeof PaymentRenewWaitingNotificationRequestAllOfPeriod[keyof typeof PaymentRenewWaitingNotificationRequestAllOfPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentRenewWaitingNotificationRequestAllOfPeriod = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY',
} as const;

export type PaymentRenewWaitingNotificationRequestAllOf = {
  userId: string;
  language: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  country: string;
  product: string;
  billingEmail: string;
  bankSubject: string;
  bankName: string;
  bankIban: string;
  bankSwift: string;
  bankAccount: string;
  variable: string;
  amountTotal: string;
  amountCurrency: string;
  period: PaymentRenewWaitingNotificationRequestAllOfPeriod;
  invoiceUrl: string;
  invoiceDueDate: string;
  invoice: NotificationAttachmentRequest;
};

export type PaymentCompletedNotificationRequestAllOfPeriod = typeof PaymentCompletedNotificationRequestAllOfPeriod[keyof typeof PaymentCompletedNotificationRequestAllOfPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentCompletedNotificationRequestAllOfPeriod = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY',
} as const;

export type PaymentCompletedNotificationRequestAllOf = {
  userId: string;
  language: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  country: string;
  product: string;
  billingEmail: string;
  amountTotal: string;
  amountCurrency: string;
  period: PaymentCompletedNotificationRequestAllOfPeriod;
  paidAt: string;
  invoiceUrl: string;
  invoice: NotificationAttachmentRequest;
};

export type PaymentCompletedNotificationRequest = NotificationRequest & PaymentCompletedNotificationRequestAllOf;

export type NotificationRequestType = typeof NotificationRequestType[keyof typeof NotificationRequestType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationRequestType = {
  TEST: 'TEST',
  NEW_REPORT: 'NEW_REPORT',
  PAYMENT_WAITING: 'PAYMENT_WAITING',
  PAYMENT_RENEW_WAITING: 'PAYMENT_RENEW_WAITING',
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
  SUBSCRIPTION_CANCELLED: 'SUBSCRIPTION_CANCELLED',
  SUBSCRIPTION_EXPIRED: 'SUBSCRIPTION_EXPIRED',
} as const;

export interface NotificationRequest {
  type: NotificationRequestType;
}

export type PaymentRenewWaitingNotificationRequest = NotificationRequest & PaymentRenewWaitingNotificationRequestAllOf;

export interface NotificationAttachmentRequest {
  data: string;
  fileName: string;
  contentType: string;
}

export type NewReportNotificationRequestAllOf = {
  title: string;
  body: string;
  link: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  language: string;
  image?: string;
};

export type NewReportNotificationRequest = NotificationRequest & NewReportNotificationRequestAllOf;

export type WebNotificationToType = typeof WebNotificationToType[keyof typeof WebNotificationToType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebNotificationToType = {
  TEST: 'TEST',
  NEW_REPORT: 'NEW_REPORT',
  PAYMENT_WAITING: 'PAYMENT_WAITING',
  PAYMENT_RENEW_WAITING: 'PAYMENT_RENEW_WAITING',
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
  SUBSCRIPTION_CANCELLED: 'SUBSCRIPTION_CANCELLED',
  SUBSCRIPTION_EXPIRED: 'SUBSCRIPTION_EXPIRED',
} as const;

export interface WebNotificationTo {
  id: number;
  title: string;
  body: string;
  image?: string;
  type: WebNotificationToType;
  archivedAt?: string;
  createdAt: string;
}




type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


  /**
 * @summary Archive notification by it`s ID
 */
export const archiveNotification = (
    id: number,
 options?: SecondParameter<typeof notificationsInstance>,) => {
      return notificationsInstance<WebNotificationTo>(
      {url: `/can-notifications/api/notification/${id}/archive`, method: 'PUT'
    },
      options);
    }
  
/**
 * @summary Send a notification
 */
export const sendNotification = (
    sendNotificationBody: SendNotificationBody,
 options?: SecondParameter<typeof notificationsInstance>,) => {
      return notificationsInstance<void>(
      {url: `/can-notifications/internal/api/notification`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendNotificationBody
    },
      options);
    }
  
/**
 * @summary Create a new push token registration
 */
export const create = (
    pushCreateRequest: PushCreateRequest,
 options?: SecondParameter<typeof notificationsInstance>,) => {
      return notificationsInstance<void>(
      {url: `/can-notifications/api/push`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pushCreateRequest
    },
      options);
    }
  
/**
 * @summary List all notifications for a user
 */
export const getNotifications = (
    
 options?: SecondParameter<typeof notificationsInstance>,) => {
      return notificationsInstance<WebNotificationTo[]>(
      {url: `/can-notifications/api/notification`, method: 'GET'
    },
      options);
    }
  
export type ArchiveNotificationResult = NonNullable<Awaited<ReturnType<typeof archiveNotification>>>
export type SendNotificationResult = NonNullable<Awaited<ReturnType<typeof sendNotification>>>
export type CreateResult = NonNullable<Awaited<ReturnType<typeof create>>>
export type GetNotificationsResult = NonNullable<Awaited<ReturnType<typeof getNotifications>>>
